import { omit } from 'lodash'
import { create } from 'zustand'

interface QueryFilterState {
  formData: {
    counties: string[]
    owners: string[]
    gsas: string[]
    water_districts: string[]
    main_crops: string[]
    max_hs: number
    min_hs: number
    max_ss: number
    min_ss: number
    record_limit: number
    max_acreage?: number
    min_acreage?: number
  }
  setFormData: (data: QueryFilterState['formData']) => void
  resetForm: () => void
  resetValue: (field: keyof QueryFilterState['formData']) => void
  updateValue: (field: keyof QueryFilterState['formData'], value: any) => void
}

export const initialState = {
  counties: [],
  owners: [],
  gsas: [],
  water_districts: [],
  main_crops: [],
  max_hs: 100,
  min_hs: 0,
  max_ss: 100,
  min_ss: 0,
  record_limit: 10,
}

export const useQueryFilterStore = create<QueryFilterState>()((set) => ({
  formData: initialState,
  setFormData: (data) => set({ formData: data }),
  resetForm: () => set({ formData: initialState }),
  resetValue: (field) =>
    set((state) => ({
      formData: {
        ...state.formData,
        [field]:
          field in initialState
            ? initialState[field as keyof typeof initialState]
            : undefined,
      },
    })),
  updateValue: (field, value) =>
    set((state) => ({
      formData: {
        ...state.formData,
        [field]: value,
      },
    })),
}))
